import React from "react";
import { APP_NAME } from "configs/AppConfig";

const MaintenancePage = () => {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#fff",
        color: "#333",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        textAlign: "center",
        padding: "20px",
      }}
    >
      <img
        src="/img/logo.svg"
        alt={APP_NAME}
        style={{ width: "120px", marginBottom: "24px" }}
      />
      <h1
        style={{
          fontSize: "48px",
          fontWeight: "bold",
          marginBottom: "16px",
          color: "#333",
        }}
      >
        Maintenance
      </h1>
      <p
        style={{
          fontSize: "18px",
          maxWidth: "500px",
          marginBottom: "24px",
          lineHeight: "1.6",
          color: "#666",
        }}
      >
        We're currently performing scheduled maintenance. We'll be back shortly.
        Thank you for your patience.
      </p>
      <div style={{ marginTop: "40px", fontSize: "14px", color: "#888" }}>
        Copyright &copy; {`${new Date().getFullYear()}`}{" "}
        <strong>{APP_NAME}</strong>
      </div>
    </div>
  );
};

export default MaintenancePage;
